import { useAppBridge } from '@shopify/app-bridge-react'
import { useCallback, useEffect, useState } from 'react'

import { useWindowFocus } from './helpers'

interface ExtensionActivation {
  target: string
}

export interface ExtensionInfo {
  handle: string
  activations: ExtensionActivation[]
}

export const useCustomerPortalExtensionInfo = () => {
  const shopify = useAppBridge()
  const [extensionInfo, setExtensionInfo] = useState<undefined | ExtensionInfo>(undefined)

  const checkActivations = useCallback(() => {
    shopify.app.extensions().then((extensions) => {
      setExtensionInfo(
        extensions.find((extension) => extension.handle === 'paywhirl-customer-portal')
      )
    })
  }, [shopify])

  useEffect(() => {
    checkActivations()
  }, [checkActivations])

  useWindowFocus(checkActivations)

  return extensionInfo
}
